import { DropDownListProps } from "@progress/kendo-react-dropdowns";
import React, { ComponentState, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getClientListData } from "./globalDataCheckerService";
import MultiSelectDropDown from "src/control-components/multi-select-drop-down/multi-select-drop-down";
import { RefreshButton } from "./refresh-button";

export const ClientDropDownComponent = (props: clientDdlProps) => {
    const state: ComponentState = useSelector(states => {
        return states;
    });

    const { selectedClient, onChangeClient, isCheckActiveClient, switchClientValue, ...rest } = props
    const [filter, setFilter] = useState<any>();
    const { clientList } = state['DocumentReducer'];
    const [clientsList, setClientsList] = useState([]);
    const [loading, setLoading] = useState(false)
    const [isDataLoadStart, setDataLoadStart] = useState(false);

    function onFilterChange(event, listName) {
        setFilter({ ...filter, [listName]: event.filter });
    }
    useEffect(() => {

        if (!isDataLoadStart) {
            setLoading(true)
            callClientListApiData(false)
            setDataLoadStart(true)
        }
        if (clientList != null) {
            setLoading(false)
            setClientsList(clientList);
        }
    }, [isDataLoadStart, clientList])

    const refreshData = () => {
        setLoading(true)
        setClientsList([])
        callClientListApiData(true)
    }
    const callClientListApiData = async (isHardRefresh: boolean) => {
         getClientListData(isHardRefresh,clientList, isCheckActiveClient, switchClientValue)
    }

    
    function renderToItem(li, itemProps) {
        const itemChildren = (
          <span>
            <input
              type="checkbox"
              name={itemProps.dataItem}
              checked={itemProps.selected}
              onChange={(e) => itemProps.onClick(itemProps.index, e)}
            />
            &nbsp;{li.props.children}
          </span>
        );
        return React.cloneElement(li, li.props, itemChildren);
    }
    
    return <div className="">
        <div className="row">
            <div className="col-md-12">
            {/* <Tooltip anchorElement="target" position="bottom" >
                    <img src={refreshImageBlue} alt="refresh" title="Refresh" className="cursor-pointer refreshSyncBlue"
                        onClick={() => { refreshData() }} />
                </Tooltip> */}
                            <RefreshButton
                                onRefresh={(event) => {
                                    setLoading(true)
                                    setClientsList([])
                                    callClientListApiData(true)
                                }}
                            />
                
                            <MultiSelectDropDown
                              data={clientsList}
                              textField="name"
                              label="Client"
                              name="client"
                              value={selectedClient}
                              onChange={onChangeClient}
                              autoClose={false}
                              dataItemKey={"id"}
                              itemRender={renderToItem}
                            />
            </div>
        </div>
    </div>
}

export interface clientDdlProps {
    selectedClient: any,
    isCheckActiveClient: boolean, 
    switchClientValue: any,
    onChangeClient?: (newValue: DropDownListProps) => void
}